import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { IntegrationSystem } from '@/shared/types';

import { WNT_ROUTES } from '@/modules/wnt/routes/config';

import { createSystemRoutes, RoutesBySystem } from '@/router/utils';

const MissingCorpses = lazy(() => import('../pages/services/MissingCorpses/MissingCorpses'));
const MissingChildrenSearch = lazy(() => import('../pages/services/MissingChildrenSearch/MissingChildrenSearch'));
const MissingPersonSearch = lazy(() => import('../pages/services/MissingPersonSearch/MissingPersonSearch'));
const MissingIncapacitatedPersons = lazy(
  () => import('../pages/services/MissingIncapacitatedPersons/MissingIncapacitatedPersons'),
);
const WantedPersonSearch = lazy(() => import('../pages/services/WantedPersonSearch/WantedPersonSearch'));
const MissingPassport = lazy(() => import('../pages/services/MissingPassport/MissingPassport'));
const MissingPhone = lazy(() => import('../pages/services/MissingPhone/MissingPhone'));
const WantedArt = lazy(() => import('../pages/services/WantedArt/WantedArt'));
const WantedWeapon = lazy(() => import('../pages/services/WantedWeapon/WantedWeapon'));
const VehicleSearch = lazy(() => import('../pages/services/VehicleSearch/VehicleSearch'));
const CheckExtractVerification = lazy(
  () => import('../pages/services/CheckExtractVerification/CheckExtractVerification'),
);

export const wntSystemComponents: Record<
  keyof RoutesBySystem<IntegrationSystem.WNT>,
  React.LazyExoticComponent<React.FC<any>>
> = {
  MISSING_PASSPORT: MissingPassport,
  MISSING_PHONE: MissingPhone,
  WANTED_WEAPON: WantedWeapon,
  WANTED_ART: WantedArt,
  MISSING_INCAPACITATED_PERSONS: MissingIncapacitatedPersons,
  MISSING_CORPSES: MissingCorpses,
  WANTED_PERSON_SEARCH: WantedPersonSearch,
  MISSING_PERSON_SEARCH: MissingPersonSearch,
  MISSING_CHILDREN_SEARCH: MissingChildrenSearch,
  VEHICLE_SEARCH: VehicleSearch,
  CHECK_EXTRACT_VERIFICATION: CheckExtractVerification,
};

export const WNTRoutes: RouteObject = createSystemRoutes(IntegrationSystem.WNT, WNT_ROUTES, wntSystemComponents);
